const drowNote = require('./drow')

module.exports = [
  drowNote,
  {
    text: `Маги Дроу могут быть весьма неплохо обученными определённым магическим навыкам. Некоторые из них даже могут сотворять мои заклинания`,
    author: `Архимаг Морденкайнен`,
  },
]
